import { computed } from 'vue'
import enums from '@/utils/enum'

export const user = computed(() => ({
  ...currentUser,
  hasPermission(permission: string): boolean {
    if (typeof currentTeamPermissions === 'object' && currentTeamPermissions.length > 0) {
      // user has full access
      if (currentTeamPermissions.length === 1 && currentTeamPermissions[0] === '*') {
        return true
      }
      return currentTeamPermissions.includes(permission)
    }
    return !this.userIsTeamMember
  },
  get isGuest() {
    return typeof currentUser !== 'object'
  },
  isCompany: currentAccountType === enums.accountTypes.company,
  userIsTeamMember: currentUser.team_member !== null && typeof currentUser.team_member === 'object',
}))
